import React from 'react';
import StepHeader from '../../includes/StepHeader';
import { BDataGrid } from '../common/dataGrid/BDataGrid';
import { map, set, find, pull, isEmpty, isNull } from 'lodash';
import BeneficiarySyncActionCreator from '../../actions/BeneficiarySyncActionCreator';
import BeneficiarySyncStore from '../../stores/BeneficiarySyncStore';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import LoaderComponent from '../common/LoaderComponent';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import InternetBankingActions from '../../actions/InternetBankingActions';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import { Dropdown } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import AccountsStore from '../../stores/AccountsStore';
import AccountDetailsBL from '../financial-stories/AccountDetailsNew/AccountDetailsBL';
import BrowserUtils from '../../utils/BrowserUtils';
import BenMobileSync from './BenMobileSync';

import PropTypes from 'prop-types';

let _selectedItems = [];
let _payeeCount = 0;

class BeneficiarySync extends React.Component {
  constructor(props) {
    super(props);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.getColumnMetaData = this.getColumnMetaData.bind(this);
    this.onSelectAllClicked = this.onSelectAllClicked.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSort = this.onSort.bind(this);
    this.displayPayeeList = this.displayPayeeList.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.syncBeneficiary = this.syncBeneficiary.bind(this);
    this.getFooter = this.getFooter.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getModalBody = this.getModalBody.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onContinue = this.onContinue.bind(this);
    this.getModalHeading = this.getModalHeading.bind(this);
    this.showInlineError = this.showInlineError.bind(this);
    this.onResize = this.onResize.bind(this);
    this.displayGrid = this.displayGrid.bind(this);
    this.state = {
      payeeList: [],
      showModal: false,
      showLoader: true,
      errorMessage: '',
      backConfirmation: false,
      noItemToSync: false,
      setAccount: 'Select an account',
      isUpdateDisable: true,
      selectedAccId: null,
      showFormatedAccountNoAndSortcode: null,
      chooseAccountOption: true,
      isTablet: BrowserUtils.isTabletView(),
      selectAll: false,
    };
  }

  componentWillMount() {
    window.addEventListener('resize', this.onResize);
    BeneficiarySyncStore.addChangeListener(this.onStoreChange);
    BeneficiarySyncActionCreator.fetchBeneficiaryToSync();

    const accList = AccountsStore.getALlPaymentCapableAccounts();
    if (accList.length === 1) {
      this.setState({
        selectedAccId: accList[0].id,
        chooseAccountOption: false,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    _selectedItems = [];
    BeneficiarySyncStore.removeChangeListener(this.onStoreChange);
  }

  onAccountSelected(account) {
    this.setState({
      setAccount: account.displayName,
      selectedAccId: account.id,
      showFormatedAccountNoAndSortcode:
        AccountDetailsBL.getAccountDisplayNumber(account),
    });
    this.showInlineError('accntErr', 'dropdown-custom-menu', false);
  }

  onCancel() {
    this.closeModal();
  }

  onContinue() {
    if (!this.state.backConfirmation) this.closeModal();
    this.setState({ showModal: false, backConfirmation: false });
  }

  onResize() {
    this.state.isTablet !== BrowserUtils.isTabletView() &&
      this.setState({ isTablet: BrowserUtils.isTabletView() });
  }

  onRowSelect(selectedRow, isSelected) {
    const row = find(this.state.payeeList, { id: selectedRow.id });
    if (row) set(row, 'isSelected', isSelected);

    isSelected
      ? _selectedItems.push(row.id)
      : (_selectedItems = pull(_selectedItems, row.id));
    this.enableDisableButton();
  }

  onSelectAllClicked(selectedRowIds, isSelected) {
    _selectedItems = [];
    map(this.state.payeeList, (rowData) => {
      set(rowData, 'isSelected', isSelected);
      if (isSelected) _selectedItems.push(rowData.id);
    });
    this.enableDisableButton();
  }

  onSort() {
    this.setState({ payeeList: this.state.payeeList.reverse() });
  }

  onStoreChange() {
    if (BeneficiarySyncStore.isSyncFinished()) {
      this.setState({ showLoader: false, showModal: true });
    } else if (!BeneficiarySyncStore.isServiceFail()) {
      const pList = BeneficiarySyncStore.getResponse();

      if (isEmpty(pList)) {
        this.setState({ showModal: true, noItemToSync: true });
      } else {
        _payeeCount = pList.length;
        this.setState({
          payeeList: pList,
          showLoader: false,
          showModal: false,
        });
      }
    } else {
      this.setState({
        errorMessage: BeneficiarySyncStore.getResponse(),
        showModal: true,
      });
    }
  }

  getColumnMetaData() {
    const columnData = [
      {
        columnName: 'id',
        order: 1,
        locked: false,
        visible: false,
        displayName: 'id',
      },
      {
        columnName: 'name',
        order: 2,
        locked: false,
        visible: true,
        displayName: 'Payee name',
        sortable: true,
        sortDirectionCycle: ['desc', 'asc'],
        cssClassName: 'beneficiary__name__column',
      },
      {
        columnName: 'nickname',
        order: 3,
        locked: false,
        visible: false,
        displayName: 'Nickname',
        sortable: false,
        cssClassName: 'beneficiary__description__column',
      },
      {
        columnName: 'accountNoForDisplay',
        order: 4,
        locked: false,
        visible: false,
        displayName: 'Sort code and account number ',
        sortable: false,
        cssClassName: 'beneficiary-account__type__column',
      },
      {
        columnName: 'reference',
        order: 5,
        locked: false,
        visible: false,
        displayName: 'Reference',
        sortable: false,
        cssClassName: 'beneficiary__reference__column',
      },
    ];
    return columnData;
  }

  getFooter() {
    const { benSyncPopupYesButton, benSyncPopupNoButton, ok } =
      this.props.content;
    let footerButtons = '';

    if (this.state.backConfirmation) {
      footerButtons = (
        <div className="review-modal__options">
          <button
            type="button"
            onClick={this.onCancel}
            className="c-btn c-btn--secondary c-modal__button"
          >
            {benSyncPopupYesButton}
          </button>
          <button
            type="button"
            onClick={this.onContinue}
            className="c-btn c-btn--default c-modal__button"
          >
            {benSyncPopupNoButton}{' '}
          </button>
        </div>
      );
    } else if (this.state.noItemToSync || this.state.errorMessage) {
      footerButtons = (
        <div className="review-modal__options">
          <button
            type="button"
            onClick={this.closeModal}
            className="c-btn c-btn--default c-modal__button"
          >
            {ok}
          </button>
        </div>
      );
    }
    return footerButtons;
  }

  getModalBody() {
    const {
      benSyncCancelPopupBody,
      benSyncSuccesBody,
      ok,
      benSyncNoPayeeBody,
    } = this.props.content;

    if (!isEmpty(this.state.errorMessage)) return this.state.errorMessage;

    if (this.state.backConfirmation) return benSyncCancelPopupBody;

    if (this.state.noItemToSync) return benSyncNoPayeeBody;

    const successSyncCount = BeneficiarySyncStore.getSuccessSyncCount() > 0;

    if (BeneficiarySyncStore.isSyncFinished()) {
      const successBody = (
        <div className="alerts-success">
          {successSyncCount && (
            <svg viewBox="0 0 32 32" width="128px" height="128px">
              <use xlinkHref="../images/bow/bow-sprite.svg#icon-success" />
            </svg>
          )}
          <label
            ref="acklabel"
            tabIndex="-1"
            className="type--orkney remove-outline"
          >
            {successSyncCount
              ? benSyncSuccesBody
              : 'Something went wrong! Please try later'}
          </label>
          <div>
            <button
              type="submit"
              className="c-btn c-btn--default"
              onClick={this.closeModal}
            >
              {ok}
            </button>
          </div>
        </div>
      );

      return successBody;
    }

    return '';
  }

  getModalHeading() {
    const { benSyncCancelPopupHeader, benSyncNoPayeeHeader } =
      this.props.content;

    if (this.state.backConfirmation) return benSyncCancelPopupHeader;
    if (this.state.noItemToSync) return benSyncNoPayeeHeader;
    return '';
  }

  closeModal() {
    MoveMoneyStore.setDisplayManagePayeePage(true);
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
  }

  displayAccountDropDown() {
    const dropDown = [];
    const accountList = AccountsStore.getAccounts();
    map(accountList, (account, index) => {
      if (account.actionsAvailable['/account/payments/uk/default/out']) {
        const accountNumber = AccountDetailsBL.getAccountDisplayNumber(account);
        const accountDropDown = (
          <MenuItem
            eventKey={index.toString()}
            onSelect={this.onAccountSelected.bind(this, account)}
          >
            <span className="account-name">{account.displayName}</span>
            <span className="account-number">
              <span className="u-visually-hidden off-screen">
                Account Sort Code and Account Number
              </span>
              {accountNumber}
            </span>
          </MenuItem>
        );
        dropDown.push(accountDropDown);
      }
    });
    return dropDown;
  }

  displayAccounts() {
    const { benSyncChooseAccountHeader, benSyncChooseAccountBody } =
      this.props.content;
    const accList = (
      <div className="c-field" ref="accntErr">
        <label
          id="chooseLabel"
          className="c-field__label c-field__label--block"
          htmlFor="dropdown-custom-menu"
        >
          {benSyncChooseAccountHeader}
          <div className="c-field__instructions">
            {benSyncChooseAccountBody}
          </div>
        </label>
        <div className="c-field__controls">
          <div className="btn-toolbar">
            <Dropdown
              id="dropdown-custom-menu"
              name="dropdown-custom-menu"
              className="custom-dropdown"
              aria-invalid="false"
              aria-required="true"
              aria-live="accountError"
              data-parent="accntErr"
            >
              <Dropdown.Toggle
                noCaret
                aria-labelledby="chooseLabel selectedValue"
                className="custom-dropdown__btn"
              >
                <span
                  id="selectedValue"
                  className="btn--title btn--title--multiline"
                >
                  <span>{this.state.setAccount}</span>
                  {this.state.showFormatedAccountNoAndSortcode && (
                    <span>{this.state.showFormatedAccountNoAndSortcode}</span>
                  )}
                </span>
                <span className="symbol">
                  <svg width="32" height="61" viewBox="0 0 32 32" role="img">
                    <path d="M19.55 12.602l1.884 1.833-5.717 5.565-5.717-5.565 1.883-1.833 3.833 3.731z" />
                  </svg>
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu>{this.displayAccountDropDown()}</Dropdown.Menu>
            </Dropdown>
          </div>
          <div
            role="alert"
            id="accountError"
            className="c-field__message"
            ref="dropdown-custom-menu"
          />
        </div>
      </div>
    );

    return accList;
  }

  displayGrid() {
    const columnsList = [
      'name',
      'nickname',
      'accountNoForDisplay',
      'reference',
    ];
    const { benSyncFooterMessage } = this.props.content;
    if (!this.state.isTablet) {
      return (
        <div className="oldTable">
          <BDataGrid
            ref="TransactionHistoryGrid"
            selectedRowIds={_selectedItems}
            results={this.state.payeeList}
            columns={columnsList}
            columnMetadata={this.getColumnMetaData()}
            initialSortAscending={false}
            onSort={this.onSort}
            isMultipleSelection
            rowAllSelected={this.onSelectAllClicked}
            rowSelected={this.onRowSelect}
            onRowClick={this.onRowClick}
            initialSort={columnsList[0]}
            showPager={false}
            useFixedHeader
            isFooterEnabled
            rowCustomClass={'row-open'}
            content={this.props.content}
            rowExpander
            tableClassName=""
            gridFooterCss=""
            resultsPerPage={_payeeCount}
            thatsAllMessage={benSyncFooterMessage}
          />
        </div>
      );
    } else {
      const attr = {};
      attr['results'] = this.state.payeeList;
      attr['selectAll'] = this.state.selectAll;
      attr['selectedItems'] = _selectedItems;
      attr['onMobRowSelect'] = this.onRowSelect;
      attr['onSelectAllClicked'] = this.onSelectAllClicked;
      attr['content'] = this.props.content;
      return (
        <div>
          <BenMobileSync {...attr} />
        </div>
      );
    }
  }

  displayPayeeCount() {
    const { benSyncPayeesFound, benSyncPayeeFound } = this.props.content;
    return (
      <div className="c-field">
        <strong>{this.props.content.benSyncPickPayee}</strong>{' '}
        {`${_payeeCount} ${
          _payeeCount > 1 ? benSyncPayeesFound : benSyncPayeeFound
        }`}
      </div>
    );
  }

  displayPayeeList() {
    const { benSyncButton, back } = this.props.content;
    return (
      <div>
        {this.state.chooseAccountOption && this.displayAccounts()}
        {this.displayPayeeCount()}
        {this.displayGrid()}
        <br />
        <div className="add-edit-payee__form__options">
          <button
            className="c-btn c-btn--secondary"
            onClick={this.handleBackButton}
          >
            {back}
          </button>
          &nbsp;
          <button
            className="c-btn c-btn--default"
            disabled={this.state.isUpdateDisable}
            onClick={this.syncBeneficiary}
          >
            {benSyncButton}
          </button>
        </div>
      </div>
    );
  }

  enableDisableButton() {
    const row = find(this.state.payeeList, { isSelected: true });
    row
      ? this.setState({ isUpdateDisable: false })
      : this.setState({ isUpdateDisable: true });
  }

  handleBackButton() {
    const row = find(this.state.payeeList, { isSelected: true });
    if (row) {
      this.setState({ backConfirmation: true, showModal: true });
    } else {
      this.closeModal();
    }
  }

  showInlineError(parent, name, isError) {
    this.refs[parent].className = isError
      ? 'c-field c-field--error'
      : 'c-field';
    this.refs[name].innerHTML = isError
      ? this.props.content.benSyncChooseAccountInlineError
      : '';
  }

  syncBeneficiary() {
    if (isNull(this.state.selectedAccId)) {
      this.showInlineError('accntErr', 'dropdown-custom-menu', true);
      window.scrollTo(0, 0);
      return;
    }
    this.setState({ showLoader: true });
    BeneficiarySyncActionCreator.addBeneficiary(
      this.state.payeeList,
      this.state.selectedAccId
    );
  }

  render() {
    const {
      benSyncLandingHeader,
      benSyncLandingSubHeader1,
      benSyncLandingSubHeader2,
      back,
    } = this.props.content;
    return (
      <div className="page bow">
        <div id="site-main" className="container" role="main" tabIndex="-1">
          <div className="row">
            <div className="col-md1-18">
              {
                <StepHeader
                  showheaderCrumbs
                  headerCrumbsMessage={back}
                  headerTitle={benSyncLandingHeader}
                  onClick={this.handleBackButton}
                  headerSubtext={benSyncLandingSubHeader1}
                />
              }
              <div>{benSyncLandingSubHeader2}</div>
            </div>
          </div>
          <br />
          <section className="row">
            <div className="col-xs1-24 col-md1-18">
              <div className="transaction-details pos-r">
                {this.state.showLoader ? (
                  <LoaderComponent type={'large'} />
                ) : (
                  this.displayPayeeList()
                )}
              </div>
            </div>
          </section>
        </div>
        <PatternLibModalComponent
          show={this.state.showModal}
          customClass={'c-modal'}
          onHide={this.onContinue}
          bsSize={'medium'}
          modalHeading={this.getModalHeading()}
          modalBody={this.getModalBody()}
          modalFooter={this.getFooter()}
          modalInContainer={false}
          closeButton={this.state.backConfirmation}
        />
      </div>
    );
  }
}

BeneficiarySync.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(BeneficiarySync);
